import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryListPermissions(payload) {
  return request(`/${payload.route}`, {
    params: toQuery(payload.params),
  });
}

export async function querySavePermission(payload) {
  return request.post(`/process/${payload.routeAdd}/${payload.id}`, {
    data: payload.data,
  });
}
